import RestClient from './RestClient';
import { CronTask } from '../../models';
import { getApiErrorMessage } from './getApiErrorMessage';

class CronTasks extends RestClient {
    constructor() {
        super({
            "model": CronTask,
            "entryPoint": "cron_task",
            "resource": "cron_task",
            "resources": "cron_tasks",
            "id_field": "_id"
        });
    }

    run(id, payload = {}) {
        const requestPayload = {
            run_parameters: payload.run_parameters ?? payload.runParameters ?? {},
            body: payload.body ?? {},
            headers: payload.headers ?? {},
        };

        return this.POST(`/cron_task/run/id/${id}`, requestPayload)
            .then(async (response) => {
                if (response.ok)
                    return response;

                let json = {};
                try {
                    json = await response.json();
                } catch (_error) {
                    // ignore parse errors
                }

                throw new Error(getApiErrorMessage(json) || `HTTP ${response.status}`);
            });
    }
}

const CronTasksApi = new CronTasks();

export default CronTasksApi;
